import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { IS_PROD_ENV } from 'consts/appConsts';

export function initDatadogRum() {
  if (IS_PROD_ENV) {
    datadogRum.init({
      applicationId: window.Chime.config.DATADOG_APPLICATION_ID,
      clientToken: window.Chime.config.DATADOG_CLIENT_TOKEN,
      service: 'enrollment-client',
      env: getDatadogEnv(),
      version: window.Chime.config.GIT_COMMIT_SHA,
      sessionSampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      beforeSend: event => {
        // We do this to prevent leaking PII to Datadog Rum
        // as anyone can see the query and results
        if (
          event?.resource?.url.indexOf(
            'https://us-autocomplete-pro.api.smartystreets.com/'
          ) === 0
        ) {
          return false;
        }
      },
    });
  }
}

export function initDatadogLogs() {
  datadogLogs.init({
    applicationId: window.Chime.config.DATADOG_APPLICATION_ID,
    clientToken: window.Chime.config.DATADOG_CLIENT_TOKEN,
    service: 'enrollment-client',
    env: getDatadogEnv(),
    version: window.Chime.config.GIT_COMMIT_SHA,
    defaultPrivacyLevel: 'mask',
    forwardErrorsToLogs: true,
    sessionSampleRate: 30,
  });
}

function getDatadogEnv() {
  switch (window.Chime.config.DEPLOYMENT_ENVIRONMENT) {
    case 'prod':
      return 'production';
    case 'dev':
      return 'local';
    default:
      return window.Chime.config.DEPLOYMENT_ENVIRONMENT;
  }
}
